import { render, staticRenderFns } from "./DepComponents.vue?vue&type=template&id=621698ea&"
import script from "./DepComponents.vue?vue&type=script&lang=js&"
export * from "./DepComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports